import useNIMStore from '@/stores/modules/nim'
import { validateNull } from '@/util/validate'

export const useLoginChat = (userInfo) => {
  if (validateNull(userInfo)) return
  const NIMStore = useNIMStore()
  const { accId, yxPassword } = userInfo
  if (accId && yxPassword) {
    NIMStore.loginChat(accId, yxPassword)
  } else {
    console.log('当前用户没有云信账号或密码')
  }
}

export const useLogoutChat = () => {
  const NIMStore = useNIMStore()
  NIMStore.logoutChat()
}
